module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/2@2x_74bbcf33bbfffdcd6a9358e55fdd8330.png";